/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_No_PermissionsInputs */

const en_admin_permissions_no_permissions = /** @type {(inputs: Admin_Permissions_No_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No permissions defined yet`)
};

/**
* | output |
* | --- |
* | "No permissions defined yet" |
*
* @param {Admin_Permissions_No_PermissionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_no_permissions = /** @type {((inputs?: Admin_Permissions_No_PermissionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_No_PermissionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_no_permissions(inputs)
});
export { admin_permissions_no_permissions as "admin.permissions.no_permissions" }